import Geocode from 'react-geocode';
import { GOOGLE_MAP } from '../config/fbConfig';

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey(GOOGLE_MAP);

// Enable or disable logs. Its optional.
// Geocode.enableDebug();

const useGeoCode = ({ type, data }, cb) => {
  if (type === 'GeoLoc') {
    // Get latitude & longitude from address.
    Geocode.fromAddress(data).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        cb(null, { lat, lng });
      },
      (error) => {
        cb(error);
      }
    );
  } else {
    // Get address from latitude & longitude.
    Geocode.fromLatLng(data.lat, data.lng).then(
      (response) => {
        const address = response.results[0].formatted_address;
        cb(null, address);
      },
      (error) => {
        cb(error);
      }
    );
  }
};

export default useGeoCode;
